import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Details } from "@digdir/designsystemet-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./FAQAccordion.scss";
export const FAQAccordion = () => {
    const { t } = useTranslation();
    const [openItems, setOpenItems] = useState([]);
    const handleAccordionToggle = (e, index) => {
        if (e.target.classList.contains("plan-overview-timeline-segment")) {
            return; // Do nothing if the target is the excluded element
        }
        setOpenItems((prevOpenItems) => prevOpenItems.includes(index) ? prevOpenItems.filter((item) => item !== index) : [...prevOpenItems, index]);
    };
    const faqItems = [
        {
            title: t("FAQ.accordion.question1.title"),
            content: _jsx("p", { children: t("FAQ.accordion.question1.response") }),
        },
        {
            title: t("FAQ.accordion.question2.title"),
            content: (_jsxs(_Fragment, { children: [_jsxs("p", { className: "faq-accordion-til-info", children: [_jsxs("span", { className: "faq-accordion-til-info-label", children: [t("FAQ.accordion.question2.fyi"), ": "] }), t("FAQ.accordion.question2.fyiDetail")] }), _jsxs("p", { className: "faq-accordion-some-disturbances", children: [_jsxs("span", { className: "faq-accordion-some-disturbances-label", children: [t("FAQ.accordion.question2.someDisturbances"), ": "] }), t("FAQ.accordion.question2.someDisturbancesDetail")] }), _jsxs("p", { className: "faq-accordion-major-disturbances", children: [_jsxs("span", { className: "faq-accordion-major-disturbances-label", children: [t("FAQ.accordion.question2.majorDisturbances"), ": "] }), t("FAQ.accordion.question2.majorDisturbancesDetail")] })] })),
        },
        {
            title: t("FAQ.accordion.question3.title"),
            content: _jsx("p", { children: t("FAQ.accordion.question3.response") }),
        },
        {
            title: t("FAQ.accordion.question4.title"),
            content: _jsx("p", { children: t("FAQ.accordion.question4.response") }),
        },
        {
            title: t("FAQ.accordion.question5.title"),
            content: (_jsx(_Fragment, { children: _jsxs("p", { children: [t("FAQ.accordion.question5.response"), _jsx("a", { href: "mailto:apoc.aom@avinor.no", children: "apoc.aom@avinor.no" })] }) })),
        },
    ];
    return (_jsx("div", { color: "subtle", className: "faq-accordion", children: faqItems.map((item, index) => (_jsxs(Details, { open: openItems.includes(index), onToggle: (e) => handleAccordionToggle(e, index), children: [_jsx(Details.Summary, { children: item.title }), _jsx(Details.Content, { className: "faq-accordion-content", children: item.content })] }, index))) }));
};
